import { render, staticRenderFns } from "./outs.vue?vue&type=template&id=c9984eca&scoped=true&"
import script from "./outs.vue?vue&type=script&lang=js&"
export * from "./outs.vue?vue&type=script&lang=js&"
import style0 from "./outs.vue?vue&type=style&index=0&id=c9984eca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9984eca",
  null
  
)

export default component.exports